import { Text } from 'wix-style-react';
import * as React from 'react';
import { translate } from 'react-i18next';
export var VatId = translate()(function (_a) {
    var t = _a.t, vatId = _a.vatId;
    return vatId ? (React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, dataHook: "customer-vat-id" }, "".concat(t('invoice-view:quote.form.vat_id'), ": ").concat(vatId))) : null;
});
//# sourceMappingURL=CustomerVatId.js.map